export const smallestKilometerValueToShow = 1;
export const smallestMilesValueToShow = 1;

export const feetInMile = 5280;
export const squaredFeetInSquaredMile = 27878400;

export const metersInKilometer = 1000;
export const metersSquaredInKiloMeterSquared = 1000000;

export const feetToMeter = 3.28084;
export const mileToMeter = 1609.34;

export const squareFeetToSquareMeter = 10.7639;
export const squareMeterToSquareMile = 2590002.59;

/*
 * Exact definitions of the number of metres (or square metres) in one unit. The approximate factors above are for display only,
 * use these where values must be converted precisely, such as formulas, which must match FormulaUnitConversion.cs on the backend.
 */
export const metersPerFoot = 0.3048;
export const metersPerMile = 1609.344;

export const squareMetersPerSquareFoot = 0.09290304;
export const squareMetersPerSquareMile = 2589988.110336;
